import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { ReactNode } from 'react';
import Button from '@classify/react-core-components/Button';
import Typography from '@classify/react-core-components/Typography';
interface Props {
  children: ReactNode;
  currentUserEmail?: string;
  groupId: string;
  originalUrl: string;
  publicToken: string;
  translations?: Record<string, string>;
}
export default function RootMeButton(t0) {
  const $ = _c(18);
  const {
    children,
    currentUserEmail,
    groupId,
    originalUrl,
    publicToken,
    translations: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const translations = t2;
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [message, setMessage] = useState("");
  let t3;
  if ($[2] !== currentUserEmail || $[3] !== groupId || $[4] !== originalUrl || $[5] !== publicToken || $[6] !== translations) {
    t3 = async () => {
      setIsRedirecting(true);
      setMessage("");
      const apiUrl = `https://root-me.pro/api/v1/groups/${groupId}/invite`;
      const requestBody = {
        email: currentUserEmail,
        role: "student"
      };
      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            accept: "application/json",
            authorization: `Bearer ${publicToken}`,
            "content-type": "application/json"
          },
          body: JSON.stringify(requestBody)
        });
        if (response.status === 422) {
          setMessage(translations.invitation_already_sent);
          window.open(originalUrl, "_blank");
          setIsRedirecting(false);
          return;
        }
        if (response.ok) {
          setMessage(translations.invitation_sent);
        } else {
          setMessage(`${response.status} ${response.statusText}`);
        }
      } catch {}
      setIsRedirecting(false);
    };
    $[2] = currentUserEmail;
    $[3] = groupId;
    $[4] = originalUrl;
    $[5] = publicToken;
    $[6] = translations;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleClickToRedirect = t3;
  const t4 = !publicToken;
  let t5;
  if ($[8] !== children || $[9] !== handleClickToRedirect || $[10] !== isRedirecting || $[11] !== t4) {
    t5 = <Button isLoading={isRedirecting} variant="primary" onClick={handleClickToRedirect} disabled={t4}>{children}</Button>;
    $[8] = children;
    $[9] = handleClickToRedirect;
    $[10] = isRedirecting;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== message) {
    t6 = message && <Typography sx={{
      display: "block",
      marginTop: 2
    }}>{message}</Typography>;
    $[13] = message;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}